"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _constants = require("composer-lib/lib/constants");

var _ComponentWithPartials = _interopRequireDefault(require("UIComponents/mixins/ComponentWithPartials"));

var _utils = require("composer-lib/components/clips/utils");

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _I18n = _interopRequireDefault(require("I18n"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UIPopover = _interopRequireDefault(require("UIComponents/tooltip/UIPopover"));

var _UserAttributes = _interopRequireDefault(require("composer-lib/data/model/UserAttributes"));

var CLIP_IMAGE_LEGAL_CHECK = _constants.BlogUserAttributes.CLIP_IMAGE_LEGAL_CHECK;
var COPYRIGHT_RESTRICTIONS_URL = 'https://knowledge.hubspot.com/articles/kcs_article/cos-blog/how-do-i-set-up-hubspot-collect-and-clip-content';
var INSERTS_WITHOUT_CHECK = 5;

var _default = (0, _createReactClass.default)({
  displayName: "ClipLegalPopover",
  mixins: [_ComponentWithPartials.default],
  propTypes: {
    auth: _propTypes.default.object,
    canShow: _propTypes.default.bool,
    children: _propTypes.default.node.isRequired,
    onCancelClick: _propTypes.default.func.isRequired,
    onSuccessClick: _propTypes.default.func.isRequired,
    userAttributes: _propTypes.default.instanceOf(_UserAttributes.default).isRequired
  },
  renderPopoverContent: function renderPopoverContent() {
    var _this$props = this.props,
        auth = _this$props.auth,
        onCancelClick = _this$props.onCancelClick,
        onSuccessClick = _this$props.onSuccessClick;
    var userId = auth.user.get('user_id');
    return {
      header: _react.default.createElement("h4", null, _react.default.createElement(_FormattedMessage.default, {
        message: (0, _utils.clipsLangKey)('legalImagePopover.header')
      })),
      body: _react.default.createElement("span", null, _react.default.createElement(_FormattedHTMLMessage.default, {
        message: (0, _utils.clipsLangKey)('legalImagePopover.body'),
        options: {
          closeLink: _I18n.default.SafeString('</a>'),
          openLink: _I18n.default.SafeString("<a href=\"" + COPYRIGHT_RESTRICTIONS_URL + "\" target=\"_blank\">")
        }
      })),
      footer: _react.default.createElement("div", null, _react.default.createElement(_UIButton.default, {
        onClick: this.partial(onSuccessClick, userId, CLIP_IMAGE_LEGAL_CHECK, 0),
        use: "primary"
      }, _react.default.createElement(_FormattedMessage.default, {
        message: (0, _utils.clipsLangKey)('legalImagePopover.yesButton')
      })), _react.default.createElement(_UIButton.default, {
        onClick: onCancelClick,
        use: "secondary"
      }, _react.default.createElement(_FormattedMessage.default, {
        message: (0, _utils.clipsLangKey)('legalImagePopover.noButton')
      })))
    };
  },
  render: function render() {
    var _this$props2 = this.props,
        canShow = _this$props2.canShow,
        children = _this$props2.children,
        userAttributes = _this$props2.userAttributes;
    var insertsSinceLegalCheck = userAttributes.getIn(['data', CLIP_IMAGE_LEGAL_CHECK], INSERTS_WITHOUT_CHECK);
    var open = canShow && insertsSinceLegalCheck >= INSERTS_WITHOUT_CHECK;
    return _react.default.createElement(_UIPopover.default, {
      content: this.renderPopoverContent(),
      open: open,
      placement: "right bottom",
      width: 350
    }, children);
  }
});

exports.default = _default;
module.exports = exports.default;